module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門5_6_4.8a795b81.png";